import { useState } from "react";
import clsx from "clsx";
import HOT_SRC from "@/assets/images/hot.svg";
import { ARROW_SRC } from "./icons";
import { isHotLeague, listLeagueName } from "./model";
import MatchRow from "./MatchRow";

export default function LeagueGroup({ league, matches, isHome, siteOrigin = "" }) {
  const [open, setOpen] = useState(true);
  const fifa = String(league?.id) === "1572" && isHome;
  const name = listLeagueName(league);
  const rows = Array.isArray(matches) ? matches : [];
  const shown = fifa ? rows.slice(0, 5) : rows;
  const leagueHref = `${String(siteOrigin || "").replace(/\/$/, "")}/giai-dau/${league?.slug || ""}`;

  return (
    <div
      className={clsx(
        "flex kbv-col max-md:mb-1",
        fifa && "overflow-hidden rounded-none lg:rounded border border-gray-200"
      )}
    >
      <div className={fifa ? "bg-fifa-blue px-3 py-2 md:px-[19px]" : "bg-[var(--color-foreground)] pl-2 pr-1 py-1 md:p-2"}>
        <div className="flex items-center gap-1">
          <div className="min-w-0 flex-1 flex items-center gap-1">
            {league?.logo ? (
              <img
                src={league.logo}
                alt=""
                width={25}
                height={25}
                className={clsx(
                  "w-5 h-5 shrink-0 object-contain",
                  fifa && "rounded-full bg-white/10 p-px"
                )}
              />
            ) : null}
            <a
              href={leagueHref}
              className={clsx("truncate text-sm font-semibold", fifa && "text-white hover:underline")}
            >
              {name}
            </a>
            {isHotLeague(league) ? (
              <img src={HOT_SRC} alt="HOT" width={50} height={18} className="h-[18px] w-[50px] shrink-0 object-contain" />
            ) : null}
          </div>
          <span
            className={clsx("inline-flex shrink-0 transition-transform", open && "rotate-180", fifa && "invert")}
            onClick={() => setOpen((value) => !value)}
          >
            <img src={ARROW_SRC} alt="" width={24} height={24} className="w-6 h-6" />
          </span>
        </div>
      </div>
      {open ? (
        <div className="kbv-matches flex kbv-col md:gap-2">
          {shown.map((match, index) => (
            <MatchRow
              key={match?.id ?? `${league?.id}-${index}`}
              match={match}
              isLast={index === shown.length - 1}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
}
